import * as Sentry from '@sentry/nuxt';
import FetchFactory from '../factory';

export interface TaxRates {
  post: number;
  subscription: number;
}

// Interface for tax rate response from API
interface TaxRateResponse {
  tax_rate: number;
  updates?: any;
}

const MAX_TAX_RATE = 0.3; // Emergency tax rate (30%)

class TaxModule extends FetchFactory {
  private RESOURCE = '/tax';

  async getPostRate() {
    try {
      const response = await this.call<TaxRateResponse>('get', `${this.RESOURCE}/rates/post`);
      
      // Extract tax_rate property from response object
      if (response && typeof response === 'object' && 'tax_rate' in response) {
        return response.tax_rate; // Keep original decimal format
      } else {
        Sentry.captureMessage('Invalid tax rate response format for post', {
          level: 'error',
          extra: { response }
        });
        return MAX_TAX_RATE;
      }
    } catch (error) {
      Sentry.captureException(error, {
        extra: { endpoint: `${this.RESOURCE}/rates/post` }
      });
      return MAX_TAX_RATE;
    }
  }

  async getSubscriptionRate() {
    try {
      const response = await this.call<TaxRateResponse>('get', `${this.RESOURCE}/rates/subscription`);
      
      // Extract tax_rate property from response object
      if (response && typeof response === 'object' && 'tax_rate' in response) {
        return response.tax_rate; // Keep original decimal format
      } else {
        Sentry.captureMessage('Invalid tax rate response format for subscription', {
          level: 'error',
          extra: { response }
        });
        return MAX_TAX_RATE;
      }
    } catch (error) {
      Sentry.captureException(error, {
        extra: { endpoint: `${this.RESOURCE}/rates/subscription` }
      });
      return MAX_TAX_RATE;
    }
  }
}

export default TaxModule;
